export function PaperclipIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.523 4.72a4.433 4.433 0 016.268 6.269l-5.81 5.81A2.745 2.745 0 118.1 12.917l4.595-4.595a1 1 0 111.414 1.415L9.514 14.33a.745.745 0 101.053 1.054l.22-.22a.075.075 0 01.003-.003l5.587-5.587a2.433 2.433 0 10-3.44-3.44l-5.93 5.93a3.667 3.667 0 000 5.185l.455.454a3.667 3.667 0 005.185 0l4.714-4.714a1 1 0 011.414 1.414l-4.714 4.714a5.667 5.667 0 01-8.014 0l-.454-.454a5.667 5.667 0 010-8.014l5.93-5.93z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
